export const fontSizes = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 30, 32, 36, 48, 52, 72];

export const fontOptions = fontSizes.map((size) => {
    return { key: size, text: size, value: size };
})